import React, { useEffect, useState } from 'react'
import {Form, FormGroup, Button} from 'react-bootstrap';
import { login } from '../api/api';


const AddUser = () => {

    const [data, setData ] = useState({
        email: '',
        password: '',
        name: '',
        username: '',
        phone: ''
    });

    const handleChange = (e) => {
        
        setData({ ...data, [e.target.name] : e.target.value});

    }

    const handleSubmit = async (e) => {
      e.preventDefault()
      console.log('form submitted.');
      const response = await login(data);
      console.log(response);

    }

    useEffect(() => {
        console.log(data);
    }, [data])
  return (
    <div>
      <center>
      

      <Form  
      method='post'
      onSubmit={e => handleSubmit(e)}
      className='col-lg-4 col-sm-6 col-xs-8 col-xxs-10 mt-5 m-5'>
        <h2> AddUser</h2>
        <Form.Label> Name </Form.Label>
        <FormGroup>
            
            <Form.Control type='text' placeholder='enter name'
            name='name'
            value={data.name}
            onChange={ (e) => {handleChange(e)}}
            />
        </FormGroup>
        <Form.Label> username </Form.Label>
        <FormGroup>
            
            <Form.Control type='text' placeholder='enter username'
            name='username'
            value={data.username}
            onChange={ (e) => {handleChange(e)}}
            />
        </FormGroup>

        <Form.Label> Email </Form.Label>
        <FormGroup>
            
            <Form.Control type='text' placeholder='enter email'
            name='email'
            value={data.email}
            onChange={ (e) => {handleChange(e)}}
            />
        </FormGroup>
        <Form.Label> phone </Form.Label>
        <FormGroup>
            
            <Form.Control type='number' placeholder='enter phone'
            name='phone'
            value={data.phone}
            onChange={ (e) => {handleChange(e)}}
            />
        </FormGroup>
        <Form.Label> Password </Form.Label>
        <FormGroup>
            
            <Form.Control type='password' placeholder='enter password' 
            name='password'
            value={data.password}
            onChange={ (e) => {handleChange(e)}}
            />
        </FormGroup>
        <Button type='submit' size='lg' variant='dark' className='w-25 mt-3'> Register </Button>
      </Form>
      </center>
    </div>
  )
}

export default AddUser
